export default __webpack_public_path__ + "static/media/looks.5d8525fb.svg";